import '../styles/footer.scss'
import { Link } from 'react-router-dom'
import LogoTP from '../logos/Teleperformance.svg'

export default function Footer() {

  return (
    <footer className='footer pt-3 pb-3'>
      <Link to="/">
        <div className='copyright'>
            <img id='logo2' src={LogoTP} alt='Teleperformance' width={145} className={'m-1'}/>
            <span className={'m-1'} style={{whiteSpace: 'nowrap'}}>
                COPYRIGHT 2021-2024 - Teleperformace/AI Nesting
            </span>
        </div>
      </Link>
    </footer>
  )
}